import React, { useContext } from 'react';
import { AlertColor, useTheme } from '@mui/material';
import { AlertMessage } from '@eposnow/ui-core';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UserContext } from '../../../../context/UserContext';

interface ChartBannerProps {
  title: string;
  type: AlertColor;
}

const ChartBanner = (
  {
    title,
    type
  } : ChartBannerProps
) => {
  const theme = useTheme();
  const { locale } = useContext(UserContext);

  return (
    <AlertMessage type={type} locale={locale} theme={theme} styles={{ marginBottom: 2 }} iconAlignment='baseline'>
        <Typography component="span">{title}</Typography>
    </AlertMessage>
  );
}

export default ChartBanner;
